import React, { useEffect, useRef } from 'react';

import { mount, unmount } from 'redom';

import application from 'application';

function NativeStartupAssistantReactWrapper(props) {

  const wrapperMainReference = useRef(null);
  const nativeStartupAssistantReference = useRef(null);

  useEffect(function onLoad() {

    let wrapperMain = wrapperMainReference.current;

    mount(wrapperMain, application.assistantManager.assistant);

    return function onUnload() {
      unmount(wrapperMain, application.assistantManager.assistant);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onPropsChange() {

    application.assistantManager.assistant.update(props);

  }, [props]);

  function renderMain() {

    const mainAttributes = {
      className: 'assistant-native-react-wrapper-main',
      ref: wrapperMainReference
    };

    return <div {...mainAttributes}>

    </div>;

  }

  return renderMain();

}

export default NativeStartupAssistantReactWrapper;
